
import React, { FC, useState, memo } from '../../../lib/teact/teact'
import InputText from '../../ui/InputText';
import store from '../store';
import LotCheckBox from '../ui/lotCheckBox';
import MyTextInput from '../ui/myTextInput';
import { GetLineFromGia, isCuPhapMb, isCuPhapMn } from '../utils/common';

import './contact.scss'
import './giaThuongItem.scss'
import { updateHanMucRieng } from '../redux/contactsSlice';
type OwerProps = {
    index: number;
    gia: number;
    thuong: number;
    soGiai: number;
    maxSoNhayThuong: number;
    loaiCuocId: string;
    mienDaiCuocId: number;
    hoi: number;
    nhanMax: number;
    chuyenMax: number;
    khAn: number;
    tuAn: number;
    onChange: (index: number, mienDaiCuocId: number, fieldName: string, value: any) => void;
    activeTab: number;
    showSoGiai:boolean;

}
const GiaThuongItem: FC<OwerProps> = ({
    index, gia, thuong, soGiai, loaiCuocId, maxSoNhayThuong,
    mienDaiCuocId, hoi,
    onChange,
    nhanMax,
    chuyenMax,
    khAn,
    tuAn,
    activeTab = 0,
    showSoGiai,

}) => {
    const [state, setState] = useState({
        showHanMuc: false,

    })
    const hanMuc = store.getState().contact.hanMucRieng
    const daiMt = store.getState().contact.daiMT
    const daiMtDaX = store.getState().contact.daiMTDaX
    const daiMn = store.getState().contact.daiMN
    const daiMnDaX = store.getState().contact.daiMNDaX
    const contact: any = store.getState().contact.currentContact
    function handleHmChange(e: React.ChangeEvent<HTMLInputElement>) {
        console.log('event info: id', e.target.id, e.target.value)
        const key = e.target.id;
        const value = Number(e.target.value)
        if (!isNaN(value)) {
            const payload = { key: key, nhanMax: value }
            store.dispatch(updateHanMucRieng(payload))
            console.log("Updat new value to nhanMax ", value)
        }


    }
    function RenderHanMucMienTrung() {
        let children: JSX.Element[] = []
        if (loaiCuocId == "DaX") {
            daiMtDaX.forEach(dai => {
                const key = `${loaiCuocId}:${dai}`
                const dataItem = hanMuc[key]
                if (dataItem != undefined) {
                    children.push(<MyTextInput id={`${loaiCuocId}:${dai}`}
                        label={dai}
                        value={dataItem.nhanMax||0}
                        onChange={(e) => handleHmChange(e)}
                    ></MyTextInput>)
                } else {
                    console.log('dataItem==undefined')
                    console.log('key=', key)
                }
            })
        }
        else {
            daiMt.forEach(dai => {
                const key = `${loaiCuocId}:${dai}`
                const dataItem = hanMuc[key]
                if (dataItem == undefined) {
                    console.log(`MT key not found :${key}`)
                } else {
                    nhanMax = dataItem.nhanMax||0;
                }

                children.push(<MyTextInput id={`${loaiCuocId}:${dai}`}
                    label={dai}
                    value={nhanMax}
                    onChange={(e) => handleHmChange(e)}
                ></MyTextInput>)


            })
        }
        return <>
            <div className=' item-container'>
                {children}
                <MyTextInput label='% thầu' value={`${khAn}`}
                    id={loaiCuocId + "mt_pt_thau"}
                    onChange={(e) => {
                        const value = Number(e.target.value.replace(",", "."));
                        if (!isNaN(value)) {
                            onChange(index, mienDaiCuocId, "khAn", value)
                        }
                    }
                    }
                />
            </div>
            <div></div>
        </>
    }
    function RenderHanMucMienNam() {
        let children: JSX.Element[] = []
        if (loaiCuocId == "DaX") {
            daiMnDaX.forEach(dai => {
                const key = `${loaiCuocId}:${dai}`
                const dataItem = (hanMuc as any)[key]
                let nhanMax=0;
                if (dataItem == undefined) {
                    console.log(`key not found :${key}`)
                } else {
                    nhanMax = dataItem.nhanMax||0;
                }
                children.push(<MyTextInput id={`${loaiCuocId}:${dai}`}
                    label={dai}
                    value={nhanMax}
                    onChange={(e) => handleHmChange(e)}
                ></MyTextInput>)
            })
        }
        else {
            daiMn.forEach(dai => {
                const key = `${loaiCuocId}:${dai}`
                const dataItem = hanMuc[key]
                let nhanMax = 0;
                if (dataItem == undefined) {
                    console.log(`key not found :${key}`)
                } else {
                    nhanMax = dataItem.nhanMax||0;
                }
                children.push(<MyTextInput id={`${loaiCuocId}:${dai}`}
                    label={dai}
                    value={nhanMax}
                    onChange={(e) => handleHmChange(e)}
                ></MyTextInput>)
            })
        }
        return <>
            <div className=' item-container'>
                {children}
                <MyTextInput label='% thầu' value={`${khAn}`}
                    id={loaiCuocId + "mn_pt_thau"}
                    onChange={(e) => {
                        const value = Number(e.target.value.replace(",", "."));
                        if (!isNaN(value)) {
                            onChange(index, mienDaiCuocId, "khAn", value)
                        }
                    }
                    }
                />
            </div>
            <div></div>
        </>
    }
    function IsRenderLine(): boolean {
        return contact!.tinhId == "BTH";
    }

    return (
        <div className='gia-thuong-item' key={`giaThuong${index}`}>

            <div className='gia-thuong-item-header'>{loaiCuocId}</div>

            {
                activeTab == 0
                && <div className='gia-thuong-item-data'>
                    {IsRenderLine()
                        ? <InputText label={isCuPhapMn() ? 'lai' : 'lai'} inputMode='decimal' value={`${GetLineFromGia(gia)}`}
                            onChange={(e) => {
                                const value = Number(e.target.value.replace(",", "."));
                                if (!isNaN(value)) {
                                    onChange(index, mienDaiCuocId, "lai", value)
                                    console.log("lai current is : ", value)
                                }
                            }
                            }
                            className='text-input ' />
                        : <InputText label={isCuPhapMn() ? 'Cò' : 'Giá'} inputMode='decimal' value={`${gia}`}
                            onChange={(e) => {
                                const value = Number(e.target.value.replace(",", "."));
                                if (!isNaN(value)) {
                                    onChange(index, mienDaiCuocId, "gia", value)
                                }
                            }
                            }
                            className='text-input input-gia' />
                    }
                    <div className='divider'></div>
                    <InputText label='Thưởng' inputMode='decimal' value={`${thuong}`}
                        onChange={(e) => {
                            const value = Number(e.target.value.replace(",", "."));
                            if (!isNaN(value)) {
                                onChange(index, mienDaiCuocId, "hsthuong", value)
                            }
                        }
                        }
                        className='text-input input-thuong' />
                    {isCuPhapMn() &&  showSoGiai && <>
                        <div className='divider'></div>
                        <InputText label='Số giải' inputMode='numeric' value={`${soGiai}`}
                            onChange={(e) => {
                                const value = Number(e.target.value.replace(",", "."));
                                if (!isNaN(value)) {
                                    onChange(index, mienDaiCuocId, "soGiai", value)
                                }
                            }
                            }
                            className='text-input input-so-giai' /></>
                    }
                    {isCuPhapMn() && <>
                        <LotCheckBox text='hồi' checked={hoi == 1}
                            onChange={(e) => {
                                const value = e.target.checked ? 1 : 0;
                                if (!isNaN(value)) {
                                    onChange(index, mienDaiCuocId, "hoi", value)
                                }
                            }
                            }
                        ></LotCheckBox></>}
                    {isCuPhapMb() && (loaiCuocId == "Lo" || loaiCuocId == "LoA") && <>
                        <div className='divider'></div>
                        <InputText label='Nháy' inputMode='numeric' value={`${maxSoNhayThuong}`}
                            onChange={(e) => {
                                const value = Number(e.target.value.replace(",", "."));
                                if (!isNaN(value)) {
                                    onChange(index, mienDaiCuocId, "maxSoNhayThuong", value)
                                }
                            }
                            }
                            className='text-input input-so-giai' /></>
                    }
                </div>

            }

            { // hạn mức chung miền bắc, mt,mn

                ((activeTab == 1 && mienDaiCuocId == 1) ||
                    (activeTab == 2 && (mienDaiCuocId == 2 || mienDaiCuocId == 3))) && <div className='gia-thuong-item-data'>
                    <MyTextInput label={'Nhận max'} inputMode='decimal' value={`${nhanMax}`}
                        onChange={(e) => {
                            const value = Number(e.target.value.replace(",", "."));
                            if (!isNaN(value)) {
                                onChange(index, mienDaiCuocId, "nhanMax", value)
                            }
                        }
                        }
                        inputClassName='5.5'
                        /* className='text-input ' */ />
                    <div className='divider'></div>
                    <MyTextInput label='Chuyển max' inputMode='decimal' value={`${chuyenMax}`}
                        onChange={(e) => {
                            const value = Number(e.target.value.replace(",", "."));
                            if (!isNaN(value)) {
                                onChange(index, mienDaiCuocId, "chuyenMax", value)
                            }
                        }
                        }
                        inputClassName='5.5'
                        /* className='text-input ' */ />

                    <div className='divider'></div>
                    <MyTextInput label='% thầu' inputMode='numeric' value={`${khAn}`}
                        onChange={(e) => {
                            const value = Number(e.target.value.replace(",", "."));
                            if (!isNaN(value)) {
                                onChange(index, mienDaiCuocId, "khAn", value)
                            }
                        }
                        }
                        inputClassName='2.5'
                        /* className='text-input input-so-giai' */ />
                    <div className='divider'></div>
                    <MyTextInput label='% hs' inputMode='numeric' value={`${tuAn}`}
                        id={`hm-tu-an`}
                        onChange={(e) => {
                            const value = Number(e.target.value.replace(",", "."));
                            if (!isNaN(value)) {
                                onChange(index, mienDaiCuocId, "tuAn", value)
                            }
                        }
                        }
                        inputClassName='3.5'
                        /* className='text-input input-so-giai' */ />

                </div>
            }

            {
                activeTab == 1 && mienDaiCuocId == 3 &&
                RenderHanMucMienNam()
            }
            {
                activeTab == 1 && mienDaiCuocId == 2 &&
                RenderHanMucMienTrung()
            }
        </div>
    )
}

export default memo(GiaThuongItem)